exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table[data-v-28aa128f] {\n  border-collapse: collapse;\n  width: 100%;\n  text-align: center;\n  margin-top: 10px;\n}\n.table td[data-v-28aa128f] {\n  border: 1px solid #e5e5e5;\n  background-color: #ffffff;\n  padding-top: 10px;\n}\n.table .ultimate[data-v-28aa128f] {\n  border-top: 1px solid #e5e5e5;\n  background-color: #ffffff;\n  padding: 5px;\n  border-left: none;\n  border-bottom: none;\n  border-right: none;\n}\n.table .single[data-v-28aa128f] {\n  border-left: 1px solid #e5e5e5;\n  width: 100px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28aa128f","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/children.vue
// module id = 2012
// module chunks = 0